// +----------------------------------------------------------------------
// | Desc:综合工具
// +----------------------------------------------------------------------
import Vue from 'vue';

// +----------------------------------------------------------------------
// | Desc:回车键触发
// +----------------------------------------------------------------------
Vue.prototype.$onEnter = function (callback) {
    if (typeof callback !== 'function') {
        return;
    }
    const handleEnterKey = (event) => {
        if (event.key === 'Enter') {
            callback(event);
        }
    };
    document.addEventListener('keydown', handleEnterKey);
    return () => {
        document.removeEventListener('keydown', handleEnterKey);
    };
};


// +----------------------------------------------------------------------
// | Desc:深拷贝数组
// +----------------------------------------------------------------------
Vue.prototype.$copyObj = function (data) {
    return JSON.parse(JSON.stringify(data));
}

// +----------------------------------------------------------------------
// | Desc: 复制文字
// +----------------------------------------------------------------------
Vue.prototype.$copy = function (text) {
    let _this=this;
    if (!navigator.clipboard) {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);

        if (successful) {
            _this.$msg(`${text} 已复制到剪贴板`,'success');
        } else {
            _this.$msg('复制失败','error');
        }
    } else {
        // Modern browsers
        navigator.clipboard.writeText(text).then(() => {
            _this.$msg(`${text} 已复制到剪贴板`,'success');
        }).catch(err => {
            _this.$msg('复制失败:','error');
        });
    }
}